import styles from './TeamDetailsSection.module.scss';

import React from 'react';
import Link from 'gatsby-link';
import RetinaImage from 'src/components/RetinaImage';
import { Button, Container, Row, Col } from 'reactstrap';
import { ScrollOverPack, TweenOne, FadeLeft } from 'src/components/Animations';

import ImgLaptopZoneAndWeight from 'src/images/img-laptop-zone-and-weight.png';
import ImgLaptopZoneAndWeight2x from 'src/images/img-laptop-zone-and-weight@2x.png';

export default (props) => (
  <div styleName='team-details-section'>
      <Container>
          <div styleName='text-container'>
              <div className='h2'>Team management so easy</div>
              <div className='h2 text-blue'>It's almost cheating.</div>
              <div styleName='features-table'>
                  <div styleName='feature-row'>
                      <div styleName='heading'>Invite</div>
                      <div>
                          Onboard with ease. In a few clicks, you can invite
                          anyone to Galleon. Every new seat is eligible for a free
                          tutorial on the platform.
                      </div>
                  </div>
                  <div styleName='feature-row'>
                      <div styleName='heading'>Remove</div>
                      <div>
                          Tie off loose ends. Don’t let departing employees leave
                          with access to your most sensitive customer data &mdash;
                          simply remove their user, and permissions are immediately
                          revoked.
                      </div>
                  </div>
                  <div styleName='feature-row'>
                      <div styleName='heading'>Customize</div>
                      <div>
                          Make it yours. Every user can deploy filters, download
                          data and schedule reports independently, without
                          interrupting their teammates.
                      </div>
                  </div>
              </div>
          </div>
      </Container>
      <ScrollOverPack styleName='splash-image-container'>
          <TweenOne key='0'
                    component={RetinaImage}
                    srcSet={[ImgLaptopZoneAndWeight, ImgLaptopZoneAndWeight2x]}
                    styleName='splash-image'
                    {...FadeLeft} />
      </ScrollOverPack>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/TeamDetailsSection.js